import { render } from "./Meditation.vue?vue&type=template&id=5c5701e0&scoped=true"
import script from "./Meditation.vue?vue&type=script&lang=js"
export * from "./Meditation.vue?vue&type=script&lang=js"

import "./Meditation.vue?vue&type=style&index=0&id=5c5701e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5701e0"]])

export default __exports__